<template>
  <div v-if="hasItems" :class="wrapperClass">
    <h3 v-if="title" :class="titleClass">
      {{ title }}
      <span v-if="showCount">({{ items.length }})</span>
    </h3>
    <div :class="listClass">
      <div
        v-for="(item, index) in items"
        :key="resolveItemKey(item, index)"
        :class="itemClass"
      >
        <ClassCard
          :class-data="item"
          :show-collapse="showCollapse"
        >
          <template #cta="slotProps">
            <slot
              name="cta"
              v-bind="{ ...slotProps, classData: item }"
            />
          </template>
        </ClassCard>
      </div>
    </div>
  </div>
</template>

<script>
import ClassCard from '@/components/classes/ClassCard.vue';

export default {
  name: 'ClassCardsList',
  components: {
    ClassCard,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    showCollapse: {
      type: Boolean,
      default: true,
    },
    listClass: {
      type: String,
      default: 'flex flex-col gap-4',
    },
    itemClass: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: 'text-black text-[1.4rem] font-semibold mb-3',
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    getItemKey: {
      type: Function,
      default: null,
    },
  },
  computed: {
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0;
    },
  },
  methods: {
    resolveItemKey(item, index) {
      if (typeof this.getItemKey === 'function') {
        const key = this.getItemKey(item, index);
        if (key !== undefined && key !== null) {
          return key;
        }
      }
      if (item && (item.classId !== undefined || item.start !== undefined)) {
        const parts = [];
        if (item.tenantId) {
          parts.push(item.tenantId);
        }
        if (item.classId !== undefined && item.classId !== null) {
          parts.push(item.classId);
        }
        if (item.start) {
          parts.push(item.start);
        }
        if (parts.length) {
          return parts.join('-');
        }
      }
      return `class-${index}`;
    },
  },
};
</script>

<style scoped>
.classes-row {
  display: flex;
  gap: 1.6rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0.8rem;
  scroll-snap-type: x proximity;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.classes-row::-webkit-scrollbar {
  display: none;
}

.classes-row__item {
  flex: 0 0 calc((100% - 3.2rem) / 3);
  max-width: calc((100% - 3.2rem) / 3);
  min-width: 24rem;
  scroll-snap-align: start;
}

@media (max-width: 1024px) {
  .classes-row__item {
    flex-basis: min(32rem, 80%);
    max-width: min(32rem, 80%);
  }
}

@media (max-width: 640px) {
  .classes-row {
    gap: 1.2rem;
  }

  .classes-row__item {
    min-width: 22rem;
    flex-basis: 85%;
    max-width: 85%;
  }
}
</style>
